// assets/also-recommendation.js
(function () {
  'use strict';

  // helper: normalize variant option array
  function variantOptionsArray(v) {
    if (!v) return [];
    if (Array.isArray(v.options)) return v.options;
    var arr = [];
    if ('option1' in v) arr.push(v.option1);
    if ('option2' in v) arr.push(v.option2);
    if ('option3' in v) arr.push(v.option3);
    return arr;
  }

  // simple helper: find cart icon element (tries several common selectors)
  function findCartIcon() {
    var sel = [
      '.site-header .cart',
      '#CartIcon',
      '.header-cart',
      '.cart-icon',
      '[data-cart-icon]',
      '.js-cart-link',
      '.cart-count-bubble',
      '.site-header .cart-count',
      '.cart-toggle',
      '#CartToggle'
    ];
    for (var i = 0; i < sel.length; i++) {
      var el = document.querySelector(sel[i]);
      if (el) return el;
    }
    // as ultimate fallback return body (we'll use top-right coordinates)
    return document.body;
  }

  /**
   * animateFlyImage (DANCING VERSION)
   * - imgSrc: source URL
   * - fromRect: DOMRect of source thumbnail
   * - toRect: DOMRect of destination (cart)
   *
   * Creates an <img> that follows a multi-keyframe "dance" path using
   * the Web Animations API when available, and CSS transitions as a fallback.
   */
  function animateFlyImage(imgSrc, fromRect, toRect, opts) {
    opts = opts || {};
    try {
      var fly = document.createElement('img');
      fly.src = imgSrc;
      fly.className = 'atc-fly atc-fly--anim';
      // start at the source rect (use fixed positioning)
      var startLeft = fromRect.left;
      var startTop = fromRect.top;
      var startW = fromRect.width;
      var startH = fromRect.height;

      fly.style.left = startLeft + 'px';
      fly.style.top = startTop + 'px';
      fly.style.width = Math.max(32, startW) + 'px';
      fly.style.height = Math.max(32, startH) + 'px';
      fly.style.opacity = '1';
      fly.style.transform = 'translateZ(0)';

      document.body.appendChild(fly);

      // compute delta center positions
      var fromCenterX = fromRect.left + (fromRect.width / 2);
      var fromCenterY = fromRect.top + (fromRect.height / 2);
      var toCenterX = toRect.left + (toRect.width / 2);
      var toCenterY = toRect.top + (toRect.height / 2);
      var dx = toCenterX - fromCenterX;
      var dy = toCenterY - fromCenterY;

      // final scale (shrink toward cart)
      var finalScale = Math.max(0.24, (toRect.width / fromRect.width) * 0.9);

      // create a playful path with multiple keyframes (percent positions use px translations)
      var keyframes = [
        { transform: 'translate(0px, 0px) scale(1) rotate(0deg)', opacity: 1, offset: 0 },
        { transform: 'translate(' + (dx * 0.28 - 14) + 'px, ' + (dy * 0.28 - 60) + 'px) scale(0.95) rotate(18deg)', opacity: 1, offset: 0.22 },
        { transform: 'translate(' + (dx * 0.55 + 12) + 'px, ' + (dy * 0.55 - 36) + 'px) scale(0.78) rotate(-18deg)', opacity: 1, offset: 0.47 },
        { transform: 'translate(' + (dx * 0.78 - 6) + 'px, ' + (dy * 0.78 - 12) + 'px) scale(0.54) rotate(12deg)', opacity: 0.9, offset: 0.72 },
        { transform: 'translate(' + (dx) + 'px, ' + (dy) + 'px) scale(' + finalScale + ') rotate(4deg)', opacity: 0.05, offset: 1 }
      ];

      var timing = {
        duration: opts.duration || 900,
        easing: opts.easing || 'cubic-bezier(.2,.9,.2,1)',
        iterations: 1,
        fill: 'forwards'
      };

      if (fly.animate && typeof fly.animate === 'function') {
        var anim = fly.animate(keyframes, timing);
        anim.onfinish = function () {
          try { if (fly && fly.parentNode) fly.parentNode.removeChild(fly); } catch (e) { try { fly.remove(); } catch(e2){} }
        };
      } else {
        // Fallback: chained transitions
        fly.style.transition = 'transform ' + timing.duration + 'ms ' + timing.easing + ', opacity 600ms';
        // force layout
        fly.getBoundingClientRect();
        setTimeout(function () {
          fly.style.transform = 'translate(' + (dx * 0.45) + 'px, ' + (dy * 0.45 - 40) + 'px) scale(0.85) rotate(12deg)';
        }, 80);
        setTimeout(function () {
          fly.style.transform = 'translate(' + (dx * 0.78) + 'px, ' + (dy * 0.78 - 8) + 'px) scale(0.6) rotate(-10deg)';
        }, 260);
        setTimeout(function () {
          fly.style.transform = 'translate(' + dx + 'px, ' + dy + 'px) scale(' + finalScale + ') rotate(4deg)';
          fly.style.opacity = '0.05';
        }, 520);
        setTimeout(function () {
          try { if (fly && fly.parentNode) fly.parentNode.removeChild(fly); } catch (e) { try { fly.remove(); } catch(e2){} }
        }, timing.duration + 60);
      }
    } catch (err) {
      console.warn('animateFlyImage error', err);
    }
  }

  // attaches behavior to a form generated for a recommended product
  function attachToForm(form) {
    if (!form || form.__alsoRecInitialized) return;
    form.__alsoRecInitialized = true;

    var productJsonElem = form.querySelector('script[type="application/json"].ar-product-json');
    var productData = null;
    try { if (productJsonElem) productData = JSON.parse(productJsonElem.textContent); } catch (err) { console.warn('also-recommendation: product JSON parse error', err); }
    var variants = (productData && productData.variants) || [];

    function getSelectedVariantId() {
      if (!variants.length) return null;
      var selects = Array.from(form.querySelectorAll('.ar-select'));
      if (selects.length === 0) return variants[0].id;
      var selectedValues = selects.map(function (s) { return s.value; });
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var vOptions = variantOptionsArray(v);
        var match = true;
        for (var j = 0; j < vOptions.length; j++) {
          if ((vOptions[j] || '') !== (selectedValues[j] || '')) { match = false; break; }
        }
        if (match) return v.id;
      }
      return variants[0].id;
    }

    function ensureHiddenVariantInput(variantId) {
      if (!variantId) return;
      var hidden = form.querySelector('input[name="id"]');
      if (hidden) {
        if (hidden.value !== String(variantId)) hidden.value = variantId;
      } else {
        hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'id';
        hidden.value = variantId;
        form.appendChild(hidden);
      }
    }

    // --- NEW: variant lookup + UI update helpers ---
    function findVariantById(variantId) {
      if (!productData || !productData.variants) return null;
      for (var i = 0; i < productData.variants.length; i++) {
        if (String(productData.variants[i].id) === String(variantId)) return productData.variants[i];
      }
      return null;
    }

    function findImageSrcForVariant(variant) {
      if (!variant) return null;
      // variant.featured_image or variant.image or variant.image_id mapping against productData.images
      if (variant.featured_image && (variant.featured_image.src || variant.featured_image)) {
        return variant.featured_image.src || variant.featured_image;
      }
      if (variant.image && (variant.image.src || variant.image)) {
        return variant.image.src || variant.image;
      }
      if (variant.image_id && productData && Array.isArray(productData.images)) {
        for (var ii = 0; ii < productData.images.length; ii++) {
          var im = productData.images[ii];
          // image objects might not have id; compare src or id loosely
          if (String(im.id || im.src) === String(variant.image_id) || String(im.id) === String(variant.image_id)) {
            return im.src || im;
          }
        }
      }
      // fallback: if productData.images exists, return first
      if (productData && Array.isArray(productData.images) && productData.images.length) {
        var candidate = productData.images[0];
        return (candidate && (candidate.src || candidate)) || null;
      }
      return null;
    }

    function updateThumbAndMetaForVariant(variant) {
      if (!variant) return;
      try {
        var recRoot = form.closest('.also-recommendation');
        if (!recRoot) return;

        var thumbLink = recRoot.querySelector('.also-recommendation__thumb');
        var thumbImg = thumbLink && thumbLink.querySelector('img');

        var vImageSrc = findImageSrcForVariant(variant);

        if (thumbImg && vImageSrc) {
          // cross-fade swap: create new img, fade in, then replace
          try {
            var newImg = document.createElement('img');
            newImg.src = vImageSrc;
            newImg.alt = (productData && productData.title ? productData.title + ' — ' + (variant.title || '') : (variant.title || ''));
            newImg.loading = 'lazy';
            newImg.style.width = '100%';
            newImg.style.height = '100%';
            newImg.style.objectFit = 'cover';
            newImg.style.opacity = '0';
            newImg.style.transition = 'opacity 260ms ease';

            // insert then fade
            thumbLink.appendChild(newImg);
            // small timeout to allow insertion
            requestAnimationFrame(function () {
              newImg.style.opacity = '1';
            });
            // remove old img after fade
            setTimeout(function () {
              try {
                if (thumbImg && thumbImg.parentNode) thumbImg.parentNode.removeChild(thumbImg);
              } catch (e) {}
            }, 300);
          } catch (e) {
            // fallback: direct swap
            thumbImg.src = vImageSrc;
            thumbImg.alt = (productData && productData.title ? productData.title + ' — ' + (variant.title || '') : (variant.title || ''));
          }
        }

        // Optional: update price element if present (.also-recommendation__price)
        var priceEl = recRoot.querySelector('.also-recommendation__price');
        if (priceEl && typeof variant.price !== 'undefined') {
          var priceNumber = Number(variant.price);
          if (!isNaN(priceNumber)) {
            // convert cents to currency units if needed (detect by magnitude)
            if (priceNumber > 999) priceNumber = priceNumber / 100;
            // simple formatting — you can replace with Intl.NumberFormat if desired
            // Try to preserve decimal places
            var priceStr = (Math.round(priceNumber * 100) / 100).toFixed((priceNumber % 1 === 0) ? 0 : 2);
            priceEl.textContent = (typeof Shopify !== 'undefined' && Shopify && Shopify.currency && Shopify.currency.active ? (Shopify.currency.active + ' ' + priceStr) : ('₹' + priceStr));
          }
        }
      } catch (e) {
        console.warn('also-recommendation: updateThumbAndMetaForVariant error', e);
      }
    }

    // init and bind events
    (function initOnce() {
      var vid = getSelectedVariantId();
      if (vid) ensureHiddenVariantInput(vid);
    })();

    // REPLACED change event: now updates hidden id AND swaps thumb + price when variant changes
    form.addEventListener('change', function () {
      var vid = getSelectedVariantId();
      if (vid) {
        ensureHiddenVariantInput(vid);
        var variantObj = findVariantById(vid);
        if (variantObj) updateThumbAndMetaForVariant(variantObj);
      }
    });

    // ---------- enhanced submit handler: ajax add + fly "dance" animation ----------
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var vid = getSelectedVariantId();
      if (!vid) {
        alert('Please select a valid option.');
        return false;
      }
      ensureHiddenVariantInput(vid);

      var btn = form.querySelector('.ar-add-to-cart');
      if (!btn) {
        // fallback to default submit if no button found
        form.submit();
        return;
      }

      // ensure spinner element exists inside button (for visual)
      if (!btn.querySelector('.atc-spinner')) {
        var spinner = document.createElement('span');
        spinner.className = 'atc-spinner';
        spinner.setAttribute('aria-hidden', 'true');
        btn.insertBefore(spinner, btn.firstChild);
      }
      // disable button and show loading
      btn.disabled = true;
      btn.classList.add('atc-loading', 'atc-anim-btn');

      // find a source image to fly
      var thumbImg = form.closest('.also-recommendation') && form.closest('.also-recommendation').querySelector('.also-recommendation__thumb img');
      var imgSrc = (thumbImg && thumbImg.src) ? thumbImg.src : '';

      // find cart position
      var cartEl = findCartIcon();
      var cartRect = cartEl.getBoundingClientRect();
      // fallback dest: top-right corner of viewport if cartRect is zero
      if (!cartRect || (cartRect.width === 0 && cartRect.height === 0)) {
        cartRect = { left: window.innerWidth - 40, top: 20, width: 24, height: 24 };
      }

      // prepare payload for /cart/add.js
      var formData = new FormData();
      var qty = form.querySelector('select[name="quantity"]') ? form.querySelector('select[name="quantity"]').value : (form.querySelector('input[name="quantity"]') ? form.querySelector('input[name="quantity"]').value : '1');
      formData.append('id', String(vid));
      formData.append('quantity', String(qty));

      // include any option fields in form (if name starts with 'properties' or 'options')
      var inputs = form.querySelectorAll('input, select, textarea');
      inputs.forEach(function (inp) {
        if (!inp.name) return;
        // avoid duplicating id/quantity already appended
        if (inp.name === 'id' || inp.name === 'quantity') return;
        formData.append(inp.name, inp.value);
      });

      // call AJAX add
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then(function (res) {
        if (!res.ok) throw new Error('Add-to-cart failed (' + res.status + ')');
        return res.json();
      }).then(function (json) {
        // animate flying image (dance)
        try {
          if (imgSrc && thumbImg) {
            var fromRect = thumbImg.getBoundingClientRect();
            animateFlyImage(imgSrc, fromRect, cartRect, { duration: 900 });
          }
        } catch (err) { /* ignore */ }

        // show success state
        btn.classList.remove('atc-loading');
        btn.classList.add('atc-success');
        // show check mark (we have CSS to reveal .atc-check); ensure it exists
        if (!btn.querySelector('.atc-check')) {
          var check = document.createElement('span'); check.className = 'atc-check'; check.textContent = '✓';
          btn.appendChild(check);
        }

        // re-enable after short delay
        setTimeout(function () {
          btn.classList.remove('atc-success');
          // remove check element
          var chk = btn.querySelector('.atc-check');
          if (chk) chk.parentNode.removeChild(chk);
          btn.disabled = false;
        }, 1000);

        // optional: update cart count in header if theme exposes an element like [data-cart-count]
        try {
          fetch('/cart.js', { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then(function(r){ if (!r.ok) throw new Error(); return r.json(); })
            .then(function(cart){
              var countEls = document.querySelectorAll('[data-cart-count], .cart-count, .js-cart-count, .cart-count-bubble');
              countEls.forEach(function (el) { el.textContent = (cart.item_count || 0); });
            }).catch(function(){ /* ignore */ });
        } catch (e) {}
      }).catch(function (err) {
        console.warn('also-recommendation: add to cart error', err);
        btn.classList.remove('atc-loading');
        btn.disabled = false;
        alert('Sorry, could not add to cart right now. Please try again.');
      });

      return false;
    });
  }

  // initialize all forms on page (when HTML has been injected)
  function initAlsoRecommendationForms() {
    var forms = document.querySelectorAll('.also-recommendation__form');
    forms.forEach(function (f) { attachToForm(f); });
  }

  // main function: fetch recs and inject into placeholder
  function fetchAndRenderRecommendation(opts) {
    if (!opts || !opts.sectionId || !opts.productId) return;
    var placeholderId = 'auto-also-recommendation-' + opts.sectionId;
    var placeholder = document.getElementById(placeholderId);
    if (!placeholder) {
      console.warn('also-recommendation: placeholder not found for section', opts.sectionId);
      return;
    }

    var url = '/recommendations/products.json?product_id=' + opts.productId + '&limit=6';

    fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('Network response not ok (' + res.status + ')');
        return res.json();
      })
      .then(function (data) {
        var products = data && (data.products || data);
        if (!products || products.length === 0) {
          // nothing to show
          console.info('also-recommendation: no recommendations found for product', opts.productId);
          return;
        }

        var recommended = null;
        for (var i = 0; i < products.length; i++) {
          var p = products[i];
          if (p && (p.id !== opts.productId)) { recommended = p; break; }
        }
        if (!recommended) recommended = products[0];

        // pick image defensively
        var imgSrc = '';
        if (recommended.featured_image) imgSrc = recommended.featured_image.src || recommended.featured_image;
        else if (recommended.image) imgSrc = recommended.image.src || recommended.image;
        else if (recommended.images && recommended.images.length) imgSrc = (recommended.images[0] && (recommended.images[0].src || recommended.images[0])) || '';

        var productUrl = recommended.url || (recommended.handle ? '/products/' + recommended.handle : ('/products/' + (recommended.handle || '')));
        var title = recommended.title || '';

        // build options html
        var optionsHtml = '';
        if (recommended.options && recommended.options.length) {
          for (var oi = 0; oi < recommended.options.length; oi++) {
            var opt = recommended.options[oi];
            var optName = opt.name || opt;
            var optValues = opt.values || opt;
            optionsHtml += '<label class="ar-label">' + optName;
            optionsHtml += '<select name="options[' + optName + ']" class="ar-select" aria-label="Select ' + optName + '">';
            for (var vi = 0; vi < optValues.length; vi++) {
              var v = optValues[vi];
              optionsHtml += '<option value="' + (v || '') + '">' + (v || '') + '</option>';
            }
            optionsHtml += '</select></label>';
          }
        }

        var productJsonEscaped = JSON.stringify(recommended).replace(/</g, '\\u003c');

        var html =
          '<div class="also-recommendation" data-product-id="' + (recommended.id || '') + '">' +
            '<div class="also-recommendation__header"><h3 class="also-recommendation__title">We also recommend</h3></div>' +
            '<div class="also-recommendation__card">' +
              '<a class="also-recommendation__thumb" href="' + productUrl + '">' +
                (imgSrc ? '<img src="' + imgSrc + '" alt="' + (title.replace(/"/g, '&quot;')) + '" loading="lazy">' : '') +
              '</a>' +
              '<div class="also-recommendation__meta">' +
                '<a class="also-recommendation__name" href="' + productUrl + '">' + title + '</a>' +
                '<form class="also-recommendation__form" action="/cart/add" method="post">' +
                  '<script type="application/json" class="ar-product-json">' + productJsonEscaped + '</script>' +
                  (optionsHtml ? ('<div class="also-recommendation__options">' + optionsHtml + '</div>') : ('<input type="hidden" name="id" value="' + (recommended.variants && recommended.variants.length ? recommended.variants[0].id : '') + '">')) +
                  '<label class="ar-label">Qty<select name="quantity" class="ar-qty-select" aria-label="Select Qty">' +
                    (function() { var s = ''; for (var q = 1; q <= 10; q++) s += '<option value="' + q + '">' + q + '</option>'; return s; })() +
                  '</select></label>' +
                  // include spinner span and label inside button for consistent visuals
                  '<button type="submit" class="ar-add-to-cart"><span class="atc-spinner" aria-hidden="true"></span><span class="atc-label">Add to Cart</span></button>' +
                '</form>' +
              '</div>' +
            '</div>' +
          '</div>';

        placeholder.innerHTML = html;

        // attach form handlers
        initAlsoRecommendationForms();

      })
      .catch(function (err) {
        console.warn('also-recommendation: fetch error', err);
      });
  }

  // public initializer
  function initAutoAlsoRecommendation(opts) {
    if (!opts || !opts.sectionId) return;
    fetchAndRenderRecommendation(opts);
  }

  // expose
  window.initAutoAlsoRecommendation = initAutoAlsoRecommendation;

  // process queued inits placed by inline script before asset loaded
  if (window._alsoRecPending && Array.isArray(window._alsoRecPending)) {
    window._alsoRecPending.forEach(function (o) { try { initAutoAlsoRecommendation(o); } catch (e) { /* ignore */ } });
    window._alsoRecPending = [];
  }

  // also attach form init on DOM ready (for server-rendered forms)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAlsoRecommendationForms);
  } else {
    initAlsoRecommendationForms();
  }

})();
